import type { HTMLAttributes, PropsWithChildren } from 'react'

import { combineClassnames } from 'app/common/presentation'

import styles from './Menu.module.scss'

export type MenuProps = PropsWithChildren<HTMLAttributes<HTMLDivElement>>

const Menu = ({ children, className, ...props }: MenuProps) => (
  <div className={combineClassnames(styles.menu, className)} role="menu" {...props}>
    {children}
  </div>
)

export default Menu
